import KoLoader from 'packages/loader';
import React from 'react';

const Loading = () => (
  <KoLoader />
);

export default Loading;
